import BaseResource from './BaseResource'

export default class Pallets extends BaseResource {
  static endpoint = '/api/v1/pallets' ///logistics
}
